<template>
    <transition name="modal" enter-active-class="animated fadeIn" appear>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header d-flex align-items-center">
                        <span class="modal-title font-weight-bold font-16" id="exampleModalLongTitle">ثبت چک لیست</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body m-0">
                        <div class="w-100">
                            <div class="input-style input-style-2 has-icon input-required">
                                <i class="input-icon fa fa-check color-magenta2-light"></i>
                                <input class="form-control" type="text" v-model="folder.subject" autofocus placeholder="عنوان">
                            </div>

                            <div>
                                <div class="input-style input-style-2 has-icon input-required">
                                    <i class="input-icon fa fa-calendar-check color-magenta2-light"></i>
                                    <span class="color-highlight">تاریخ سررسید</span>
                                    <input type="text"
                                           class="form-control ltr d-inline-block"
                                           v-model="folder.checkListDate"
                                           id="startDT" />

                                </div>
                                <date-picker type="date" v-model="folder.checkListDate" format="jYYYY/jMM/jDD" element="startDT" />
                            </div>
                            <div class="mb-3" v-if="isExpired==false">
                                <div class="d-flex align-items-center mb-2">
                                    <input type="checkbox" class="SendReminder" v-model="folder.sendReminder">
                                    <span class="font-weight-bold mr-2">ارسال یادآور</span>
                                </div>
                                <div class="d-flex">
                                    <input v-show="folder.sendReminder" class="form-control ltr text-left ml-1" type="text" v-model="folder.reminderDate" readonly placeholder="تاریخ یادآور">
                                    <input v-show="folder.sendReminder" class="form-control ltr text-left" type="text" id="remDT" v-model="folder.reminderTime" />
                                </div>
                                <date-picker type="time" v-model="folder.reminderTime" :auto-submit="true" format="HH:mm" element="remDT" :jumpMinute="5" />
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">
                            <button :disabled="Wait!=false" class="btn btn-xxs rounded-s bg-green2-light" @click="CreateFolder">
                                <i class="fa fa-check ml-2"></i>
                                ثبت
                            </button>
                            <button :disabled="Wait!=false" class="btn btn-xxs rounded-s bg-red1-light" @click="$emit('close')">
                                <i class="fa fa-times ml-2"></i>
                                بستن
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>

    </transition>
    <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
        <div v-if="isLoad" class="w-100 d-flex justify-content-center loadingBox">
            <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
        </div>
    </transition>
</template>


<script>
    import DatePicker from 'vue3-persian-datetime-picker';
    import VueSimpleAlert from "vue3-simple-alert";
    export default {
        components: {
            DatePicker,
        },
		props: ['Expired',"Passed"],
        data() {
            return {
                Wait: false,
                isExpired: this.Expired,
				isPassed: this.Passed,
                isLoad: false,
                folder: {
                    subject: "",
                    reminderDate: "",
                    reminderTime: "",
                    checkListDate: "",
                    sendReminder: false,
                    seq: 0,
                    checkListFolderId: 0,
                    CheckListId: 0,
                }
            }
        },
        watch: {
            'folder.checkListDate'(value) {
                this.folder.reminderDate = value;
            },
            'folder.sendReminder'(value) {
                if (value && (this.folder.checkListDate == null || this.folder.checkListDate == '')) {
                    this.folder.sendReminder = false;
                    document.getElementsByClassName("SendReminder")[0].checked = false;
                    this.showErrorMessage("ابتدا تاریخ سررسید را وارد کنید");
                    
                }
            }

        },
        methods: {
            ClraeFolder() {
                this.folder.subject = "";
                this.folder.reminderDate = "";
                this.folder.reminderTime = "";
                this.folder.checkListDate = "";
                this.folder.sendReminder = false;
                this.folder.seq = 0;
                this.folder.checkListFolderId = 0;
            },
            CreateFolder() {
                this.isLoad = true;
                this.Wait = true;
                this.$http.post("CheckList/AddFolder", this.folder)
                    .then(data => {
                        var res = data.data;
                        this.isLoad = false;
                        this.Wait = false;
                        if (res.isSuccess) {
                            this.showSuccessMessage(res.message);
							this.$store.dispatch("GetWallCheckListListFromServer", {
								isPassed: this.isPassed,
							});
                            this.$emit('close');
                        } else {
                            this.showErrorMessage(res.message);
                        }
                    });
            }
        },
        created() {
            this.ClraeFolder();
        }

    }
</script>
